/*
 *	@created: 14.01.2016, 12:07:25
 * 	@author: André Müller <entwickler@musteradresse.net>
 *
 */

//var $ = jQuery;

var iSwitchToMobile = 768;
var iMaxWidth = 960;
var iRemScaleFactor = 15;

var iStickyPosition = 100;

var tAnimationPause = 5600;
var tAnimationSpeed = 800;

(function( $ ) {
	var iWindowWidth = $(window).width();
	var iWindowHeight = $(window).height();

	$(window).resize(function(){
		iWindowWidth = $(window).width();
		iWindowHeight = $(window).height();
	});
})( jQuery );


//////////////////
// WEBPACK FOOTER
// /Users/wobble/Sites/ksg/www/typo3conf/ext/t3zeroseven/Resources/Public/Sites/Zero/Scripts/Var.js
// module id = NeED
// module chunks = 1